import { useEnqueueEngagement } from '../../../hooks';
import { SolidButtonPrimary } from 'rwl-ui';
import { ConversionType } from 'rwl-shared/dist/models/plugin/Conversion';

type ContactUsProps = {
    link?: string;
    mediaId?: string;
    workSiteId?: string;
};

export const ContactUs = ({ link }: ContactUsProps): JSX.Element | null => {
    const { enqueue } = useEnqueueEngagement();

    if (!link) {
        return null;
    }

    return (
        <SolidButtonPrimary
            href={link}
            target={'_blank'}
            className={'contactUs'}
            onClick={() => {
                enqueue({
                    type: 'Conversion',
                    conversionType: ConversionType.ContactUs,
                    target: 'Contact Us CTA',
                    clickedAt: new Date(),
                    pageUrl: window.location.href,
                });
            }}
        >
            Contact Us
        </SolidButtonPrimary>
    );
};
